import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Check from '@atlaskit/icon/glyph/check';
import { token } from '@atlaskit/tokens';

import { Day } from '../Day';
import { useUserInfo } from '../../../store/userInfoStore';

const getSevenDaysAgo = () => {
	const sevenDaysAgo = new Date();
	sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
	return sevenDaysAgo;
};

export const SecondDay = () => {
	const { billingSourceSystem } = useUserInfo();

	const secondDayTitle = (
		<div>
			{billingSourceSystem === 'CCP' ? (
				<FormattedMessage
					id="end-of-trial-payment-modals.standard.timeline.halfway.title"
					defaultMessage="{day, date, long}: Trial halfway complete"
					description="Title for trial halfway complete timeline item"
					values={{
						day: getSevenDaysAgo(),
					}}
				/>
			) : (
				<FormattedMessage
					id="end-of-trial-payment-modals.standard.timeline.7-days-left.title"
					defaultMessage="{day, date, ::MMMMd}: Trial ends in 7 days"
					description="Title for 7-days left timeline item"
					values={{
						day: getSevenDaysAgo(),
					}}
				/>
			)}
		</div>
	);

	const secondDaySubtitle = (
		<FormattedMessage
			id="end-of-trial-payment-modals.standard.timeline.7-days-left.subtitle"
			defaultMessage="Check-in on trial progress."
			description="Subtitle for 7-days left timeline item"
		/>
	);

	return (
		<Day
			title={secondDayTitle}
			subtitle={secondDaySubtitle}
			icon={
				<Check
					label="trial halfway complete"
					primaryColor={token('color.text.brand')}
					size="small"
				/>
			}
		/>
	);
};
